var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgError = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "#5f6368",
  viewBox: "0 -960 960 960"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M479.79-288q15.21 0 25.71-10.29t10.5-25.5-10.29-25.71-25.5-10.5-25.71 10.29-10.5 25.5 10.29 25.71 25.5 10.5M444-432h72v-240h-72zm36.28 336Q401-96 331-126t-122.5-82.5T126-330.96t-30-149.5 30-149.04 82.5-122T330.96-834t149.5-30 149.04 30 122 82.5T834-629.28q30 69.73 30 149Q864-401 834-331t-82.5 122.5T629.28-126q-69.73 30-149 30m-.28-72q130 0 221-91t91-221-91-221-221-91-221 91-91 221 91 221 221 91m0-312"
})));
export default SvgError;